export default {"src":"/_next/static/media/chevronUpWhite.54b438f8.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};